export default __webpack_public_path__ + "static/media/default.06fff5f8.svg";